import React from 'react';
import { Container, Stack } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { EventCoverImage } from './EventCoverImage';
import { EventRightBox, IEventSuggestion } from './EventRightBox';
import { EventDescription } from './EventDescription';
import { EventDetails } from './EventDetails';
import { EventHighlight } from './EventHighlight';
import { EventFAQ } from './EventFAQ';
import { EventRequirements } from './EventRequirements';
import { EventHost } from './EventHost';

export interface IEventWrapper extends IEventSuggestion {}

const EventWrapper: React.FC<IEventWrapper> = ({ event, ...props }) => {
    const { device } = useThemeContext();

    return (
        <Container disableGutters={device.isMobile} sx={{ minHeight: { xs: 'auto', sm: 'auto' }, height: 'auto' }}>
            <Stack
                gap={2}
                width={'100%'}
                sx={{
                    pb: {
                        xs: '30vh',
                        sm: '10px',
                    },
                }}
                direction={{
                    xs: 'column',
                    sm: 'row',
                }}
                alignItems={{
                    xs: 'flex-start',
                }}>
                <Stack width={'100%'}>
                    <Stack
                        gap={2}
                        direction={{
                            xs: 'column',
                            sm: 'row',
                        }}
                        alignItems={{
                            xs: 'flex-start',
                        }}>
                        <EventCoverImage {...props} event={event} />
                    </Stack>
                    <EventHighlight {...(props as any)} />
                    <EventDescription {...(props as any)} />
                    <EventDetails {...(props as any)} />
                    <EventRequirements {...(props as any)} />
                    <EventHost {...(props as any)} />
                    <EventFAQ {...(props as any)} />
                </Stack>
                {device.isDesktop && <EventRightBox {...props} event={event} />}
            </Stack>
            {device.isTablet && !device.isMobile && <EventRightBox disableSuggestion {...props} event={event} />}
            {device.isMobile && (
                <Stack
                    sx={{
                        position: 'fixed',
                        bottom: -20,
                        left: 0,
                        width: '100%',
                        zIndex: 10,
                    }}>
                    <EventRightBox {...props} event={event} disableSuggestion />
                </Stack>
            )}
        </Container>
    );
};

export { EventWrapper };
